/* eslint-disable global-require, no-console, no-magic-numbers */

const _state = {
    subOpen: false,
    previousMenu: null
};

const _options = {
    delay: 100,
    transition: 100
};

class HeaderNavigation {
    constructor(element, options) {
        this._element = element;
        this._state = _state;
        this._options = { ...HeaderNavigation.options, ...options, ..._options };
        this._cacheSelectors();

        this._menuLevels = {
            firstLevelMenu: 1,
            secondLevelMenu: 2,
            thirdLevelMenu: 3
        };

        this._initialize();
    }

    _cacheSelectors() {
        this._elements = {
            images: Array.from(this._element.querySelectorAll('.figure')),
            links: Array.from(
                this._element.querySelectorAll('.menu-button')
            ),
            navigationList: Array.from(
                this._element.querySelectorAll('.navigation-list')
            ),
            navigationLinksList: Array.from(
                this._element.querySelectorAll('.navigation-list__link')
            ),
            firstLevelMenu: Array.from(
                this._element.querySelectorAll('.navigation-list[data-level="1"]')
            ),
            secondLevelMenu: Array.from(
                this._element.querySelectorAll('.navigation-list[data-level="2"]')
            ),
            thirdLevelMenu: Array.from(
                this._element.querySelectorAll('.navigation-list[data-level="3"]')
            ),
            backButton: this._element.parentNode.querySelector('.menu__back__button'),
            backButtonTitle: this._element.parentNode.querySelector('#menu__active-title'),
            header: document.querySelector('.header')
        };
    }

    _initialize() {
        this._closeAllMenus();
        this._elements.firstLevelMenu.forEach(menuItem => {
            this._showMenu(menuItem);
        });


        // Make each link clickable and search for submenu
        this._elements.links.forEach(el => {
            el.addEventListener('click', event => this._clickedNavigationItem(event));
        });

        this._elements.navigationLinksList.forEach(el => {
            el.addEventListener('click', event => this._clickedNavigationItem(event));
        });

        // This._elements.backButton.addEventListener('click', () => {
        //     This._clickedBackButton();
        // });

        document.addEventListener('click', event => this._handleDocumentClicked(event));
    }

    /**
     * Close the modal when clicked outside
     *
     * @private
     * @param {event} event
     */
    _handleDocumentClicked(event) {
        if (!event.target.closest('.navigation-list') && !this._elements.navigationLinksList.includes(event.target)) {
            this._closeAllMenus();
        }
    }

    /**
     * Close all of the menus
     *
     */
    _closeAllMenus() {
        this._elements.navigationList.forEach(el => {
            el.setAttribute('data-active', false);
            el.setAttribute('data-sub-open', false);

            const li = Array.from(el.querySelectorAll('li'));
            li.forEach(liel => {
                liel.setAttribute('data-active', false);
                liel.setAttribute('data-sub-open', false);
            });
        });
    }

    /**
     * When clicked on any <li> item in the menu
     * @param {*} event
     */
    // eslint-disable-next-line complexity
    _clickedNavigationItem(event) {
        event.stopPropagation();

        const clickedElement = event.currentTarget.closest('li');
        const nextMenu = clickedElement.querySelector('ul');
        const previousMenu = event.currentTarget.closest('ul');
        const clickedElementLevel = parseInt(clickedElement.dataset.level, 10);

        // Populate back button title
        // eslint-disable-next-line no-unused-expressions
        // This._elements.backButtonTitle.setAttribute(
        //     'data-previous-title', this._elements.backButtonTitle.textContent
        // );

        // When menu is already active close the menu
        if (clickedElementLevel === this._menuLevels.firstLevelMenu) {
            if (
                nextMenu &&
                nextMenu.dataset.active === 'true'
            ) {
                this._closeAllMenus();
                this._showMenu(previousMenu);
                nextMenu.setAttribute('data-sub-open', false);
                return;
            }

            this._closeAllMenus();

        }

        // Don't open an item that is already active
        if (nextMenu && nextMenu.dataset.active === 'true') {
            return;
        }

        // This._elements.backButtonTitle.textContent = clickedElement.dataset.title;

        // If menu has a submenu, open it
        if (nextMenu) {
            Array.from(previousMenu.querySelectorAll('.navigation-list')).forEach(el => {
                el.setAttribute('data-active', false);
                el.setAttribute('data-sub-open', false);

                const li = Array.from(el.querySelectorAll('li'));
                li.forEach(liel => {
                    liel.setAttribute('data-active', false);
                    liel.setAttribute('data-sub-open', false);
                });
            });
            this._state.previousMenu = previousMenu;
            this._showMenu(nextMenu);
            this._showMenu(clickedElement);
        }
    }

    /**
     * Show menu based on either level or element
     * @param {*} element
     */
    _showMenu(element) {
        const menuLevel = parseInt(element.dataset.level, 10);

        if (menuLevel > this._menuLevels.firstLevelMenu) {
            this._state.subOpen = true;
            element.setAttribute('data-sub-open', true);
            // This._elements.backButton.setAttribute('data-visible', true);
        } else {
            this._state.subOpen = false;
            element.setAttribute('data-sub-open', false);
            // This._elements.backButton.setAttribute('data-visible', false);
        }

        this._element.setAttribute('data-show-level', menuLevel);
        this._elements.header.setAttribute('data-level', menuLevel);

        const waitForMenu = 200;
        setTimeout(() => {
            element.setAttribute('data-active', true);
            const parent = element.parentNode.closest('ul');
            // eslint-disable-next-line no-unused-expressions
            parent && parent.setAttribute('data-sub-open', true);
        }, waitForMenu);
    }

    /**
     * When the user clicks on the back button in the mobile menu
     */
    _clickedBackButton() {
        const currentShowLevel = parseInt(this._element.dataset.showLevel, 10) - this._menuLevels.firstLevelMenu;
        this._element.setAttribute('data-show-level', currentShowLevel);
        this._elements.header.setAttribute('data-level', currentShowLevel);

        this._closeAllMenus();

        if (currentShowLevel === this._menuLevels.secondLevelMenu) {
            this._showMenu(this._state.previousMenu);
            this._elements.backButtonTitle.textContent = this._elements.backButtonTitle.dataset.previousTitle;
        }

        if (currentShowLevel < this._menuLevels.secondLevelMenu) {
            this._elements.firstLevelMenu.forEach(menuItem => {
                this._showMenu(menuItem);
            });
        }
    }
}

export default HeaderNavigation;
